import * as z from "zod/v4";

export const toggleCallBeingRecorded = {
  name: "toggleCallBeingRecorded" as const,
  input: z.object({ customerCallId: z.string(), beingRecorded: z.boolean() }),
  output: z.object({}),
};
